import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ children }) => {
  const { isLoggedIn } = useSelector((store) => store.signin);
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/" state={{ location }} replace />;
  }

  return children;
};

export default RequireAuth;
